import React from 'react';
import { AppBar, Toolbar, Typography, Box } from '@mui/material';
import { FaEnvelope, FaGithub, FaLinkedin } from 'react-icons/fa';
import { Link as ScrollLink } from 'react-scroll';

function Header() {
  return (
    <AppBar position="fixed" sx={{ background: 'rgba(255,255,255,0.85)', backdropFilter: 'blur(8px)', boxShadow: 'none', borderBottom: '1px solid rgba(0,0,0,0.06)' }}>
      <Toolbar>
        <Box sx={{ flexGrow: 1 }} />
        <Box sx={{ display: 'flex', gap: 2 }}>
          <ScrollLink to="work" smooth={true} duration={500} offset={15}>
            <Typography sx={{ cursor: 'pointer', color: '#000', '&:hover': { color: '#2563EB' }, transition: 'color 0.15s' }}>Work</Typography>
          </ScrollLink>
          <ScrollLink to="projects" smooth={true} duration={500} offset={15}>
            <Typography sx={{ cursor: 'pointer', color: '#000', '&:hover': { color: '#2563EB' }, transition: 'color 0.15s' }}>Projects</Typography>
          </ScrollLink>
          <ScrollLink to="education" smooth={true} duration={500} offset={15}>
            <Typography sx={{ cursor: 'pointer', color: '#000', '&:hover': { color: '#2563EB' }, transition: 'color 0.15s' }}>Education</Typography>
          </ScrollLink>
          <ScrollLink to="resume" smooth={true} duration={500} offset={15}>
            <Typography sx={{ cursor: 'pointer', color: '#000', '&:hover': { color: '#2563EB' }, transition: 'color 0.15s' }}>Resume</Typography>
          </ScrollLink>
          <a href="https://github.com/jakeBringetto" target="_blank" rel="noopener noreferrer" style={{ color: '#000', display: 'flex', alignItems: 'center', transition: 'color 0.15s' }} onMouseEnter={e => e.currentTarget.style.color='#2563EB'} onMouseLeave={e => e.currentTarget.style.color='#000'}>
            <FaGithub />
          </a>
          <a href="https://linkedin.com/in/jakebringetto" target="_blank" rel="noopener noreferrer" style={{ color: '#000', display: 'flex', alignItems: 'center', transition: 'color 0.15s' }} onMouseEnter={e => e.currentTarget.style.color='#2563EB'} onMouseLeave={e => e.currentTarget.style.color='#000'}>
            <FaLinkedin />
          </a>
          <a href="mailto:jakebringetto@berkeley.edu" target="_blank" rel="noopener noreferrer" style={{ color: '#000', display: 'flex', alignItems: 'center', transition: 'color 0.15s' }} onMouseEnter={e => e.currentTarget.style.color='#2563EB'} onMouseLeave={e => e.currentTarget.style.color='#000'}>
            <FaEnvelope />
          </a>
        </Box>
      </Toolbar>
    </AppBar>
  );
}

export default Header;
